<template>
  <main class="d-flex align-items-center min-vh-100 py-3 py-md-0">
    <div class="container">
      <div class="card login-card">
        <div class="row no-gutters">
          <div class="col-md-5">
            <img src="@/assets/images/login.jpg"
              alt="login"
              class="login-card-img">
          </div>
          <div class="col-md-7">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

export default {
  name: 'login',
};
</script>

<style lang="scss">
@import 'bootstrap/scss/bootstrap.scss';
@import '@/assets/scss/login.scss';
</style>
